import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";
// Apne file ke top par check karo aur import list me BsCpuFill ko include kar lo:
import {
  BsArrowUpCircleFill,
  BsPeopleFill,
  BsGraphUpArrow,
  BsLightbulbFill,
  BsShieldLockFill,
  BsTruck,
  BsCheck2Square,
  BsBarChartLineFill,
  BsCheckCircleFill,
  BsBuildingUp,
  BsTelephoneForwardFill,
  BsCalendar2EventFill,
  BsPersonCheckFill,
  BsHouseGearFill,
  BsPiggyBankFill,
  BsBriefcaseFill,
  BsDropletFill,
  BsAwardFill,
  BsSunFill,
  BsSendFill,
  BsGeoAltFill,
  BsTrendingUp,
  BsCpuFill, // <--- Bas ye ek field add kar do, error instantly fix ho jayega!
} from "react-icons/bs";

import distributorship1 from "../media/Distributorship.png";
import factory from "../media/factory.jpg";
import trucks from "../media/trucks.jpg";
import food from "../media/food.jpg";
import cleanWater from "../media/clean water.png";

const Distributor = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title =
      "Franchise Logistics & Commercial Distributorship | NGO Waters";
  }, []);

  const [submissionStatus, setSubmissionStatus] = useState({
    type: null,
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Comprehensive Franchise Requirements State
  const [formInputs, setFormInputs] = useState({
    name: "",
    firmName: "",
    email: "",
    mobile: "",
    pincode: "",
    city: "",
    state: "",
    investmentCapacity: "",
    storageSpace: "",
    existingBusiness: "",
    distributionExperience: "",
    vehicleAvailable: "No",
    infrastructureReady: "No",
    additionalNotes: "",
  });

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormInputs((prev) => ({ ...prev, [id]: value }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmissionStatus({ type: null, message: "" });

    try {
      const targetBaseUrl =
        import.meta.env?.VITE_API_URL || "http://localhost:5000";
      await axios.post(`${targetBaseUrl}/api/distributorship`, formInputs);
      setSubmissionStatus({
        type: "success",
        message:
          "Franchise intent logged successfully. Our territory commercial desk will review your infrastructure parameters and connect within 24-48 hours.",
      });
      // Reset form to default states
      setFormInputs({
        name: "",
        firmName: "",
        email: "",
        mobile: "",
        pincode: "",
        city: "",
        state: "",
        investmentCapacity: "",
        storageSpace: "",
        existingBusiness: "",
        distributionExperience: "",
        vehicleAvailable: "No",
        infrastructureReady: "No",
        additionalNotes: "",
      });
    } catch (error) {
      setSubmissionStatus({
        type: "error",
        message:
          "Transmission layer error. Unable to route franchise metadata. Check network logs or try again.",
      });
    }
    {
      setIsSubmitting(false);
    }
  };

  const dataset = {
    intro: {
      title:
        "NGO Waters: Engineered for maximum purity, commanding high regional consumer trust.",
      description:
        "Deploying 10 specialized high-velocity SKUs designed perfectly to adapt to wholesale procurement layers and retail environments.",
      image: distributorship1,
    },
    futureGrowth: [
      "Tap extensive downstream retail chains across Tier-2 & Tier-3 sectors.",
      "Deploy custom multi-volume 10-SKU catalogs targeting distinct consumer brackets.",
      "Leverage scaling logistical distribution lanes backed by Ponia Food & Beverage.",
      "Benefit from standard commercial margins with high consumer pull.",
    ],
    benefits: [
      {
        icon: <BsPiggyBankFill />,
        title: "Optimized Investment",
        desc: "Start with structured capital tiers designed for fast operational rollout.",
      },
      {
        icon: <BsPeopleFill />,
        title: "Franchise Support",
        desc: "Direct support from our territory heads for deployment, branding, and local penetration.",
      },
      {
        icon: <BsGraphUpArrow />,
        title: "Steady Ledger Volatility",
        desc: "Consistent month-on-month market consumption loops ensure stable cashflows.",
      },
      {
        icon: <BsLightbulbFill />,
        title: "Mineral Consistency",
        desc: "IS 14543 certification parameters mean zero quality friction in the market.",
      },
      {
        icon: <BsShieldLockFill />,
        title: "Secure Territory Contract",
        desc: "Exclusive geographic operating rights block competitor leakage chains.",
      },
      {
        icon: <BsTruck />,
        title: "Predictable Fleet Inbound",
        desc: "Direct factory dispatches optimize turnaround latency for warehouse stocks.",
      },
      {
        icon: <BsCheck2Square />,
        title: "B2B Sales Matrix Training",
        desc: "Acquire specialized operational manuals to unlock institution supply contracts.",
      },
      {
        icon: <BsBarChartLineFill />,
        title: "Dynamic Scaling Radius",
        desc: "Add downstream sub-distribution nodes seamlessly as regional demand builds.",
      },
      {
        icon: <BsCheckCircleFill />,
        title: "High Brand Reliability",
        desc: "Leverage a clean commercial identity that immediately clears retail compliance checks.",
      },
      {
        icon: <BsBuildingUp />,
        title: "FMCG Capital ROI Ratios",
        desc: "Accelerated inventory churn values reduce dead storage overheads.",
      },
      {
        icon: <BsTelephoneForwardFill />,
        title: "Dedicated Help Desk",
        desc: "Direct access to our plant dispatch coordination team for inventory logs.",
      },
      {
        icon: <BsCalendar2EventFill />,
        title: "Annual Consensus Meets",
        desc: "Collaborate directly with network founders on pricing and market strategies.",
      },
      {
        icon: <BsPersonCheckFill />,
        title: "Direct Network Synergy",
        desc: "Exchange regional strategy modules with logistics operators nationwide.",
      },
      {
        icon: <BsHouseGearFill />,
        title: "Flexible Backend Setup",
        desc: "Operate out of decentralized base units minimizing administrative friction.",
      },
      {
        icon: <BsArrowUpCircleFill />,
        title: "Expanding Territory Cap",
        desc: "Unlock priority rights for neighboring geographic pincodes upon target completion.",
      },
    ],
    businessBenefits: [
      {
        icon: <BsBarChartLineFill className="text-primary fs-3" />,
        title: "Optimized Yield",
      },
      {
        icon: <BsGraphUpArrow className="text-success fs-3" />,
        title: "High Demand Velocity",
      },
      {
        icon: <BsShieldLockFill className="text-danger fs-3" />,
        title: "Protected Accounts",
      },
      {
        icon: <BsCpuFill className="text-warning fs-3" />,
        title: "Automated Supply Chain",
      },
    ],
    communityImpact: [
      {
        icon: <BsBriefcaseFill className="text-primary fs-4" />,
        title: "Socio-Economic Alliance",
        desc: "Establishing decentralized distribution systems that provide direct regional livelihood nodes.",
      },
      {
        icon: <BsDropletFill className="text-info fs-4" />,
        title: "Pure Water Access Layer",
        desc: "Channelling 50% of net retail profits into zero-cost rural pipeline projects.",
      },
      {
        icon: <BsAwardFill className="text-warning fs-4" />,
        title: "Educational Allocations",
        desc: "Deploying financial buffers directly to upgrade public instruction facilities in under-resourced sectors.",
      },
      {
        icon: <BsBuildingUp className="text-secondary fs-4" />,
        title: "Regional Skill Multiplier",
        desc: "Imparting formal technical inventory handling certifications to local plant staff.",
      },
      {
        icon: <BsSunFill className="text-danger fs-4" />,
        title: "Sustainable Ecosystem Focus",
        desc: "Driving clean energy options and high-efficiency filtration targets to reduce ecological stress.",
      },
    ],
    stats: [
      { title: "1 Automated Production Hub", image: factory },
      { title: "5 Enterprise Distribution Nodes", image: food },
      { title: "Strategic Fleet Dispatch Units", image: trucks },
    ],
  };

  const springSettings = { type: "spring", stiffness: 50, damping: 15 };
  const clickFeedback = { type: "spring", stiffness: 300, damping: 20 };

  return (
    <motion.div
      className="container-fluid py-5 px-3 px-md-5 bg-light"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
      style={{ fontFamily: "'Inter', sans-serif" }}
    >
      {/* Background aesthetics */}
      <div
        className="position-absolute rounded-circle"
        style={{
          width: "550px",
          height: "550px",
          background: "rgba(54, 191, 216, 0.03)",
          top: "-100px",
          right: "0px",
          filter: "blur(130px)",
          pointerEvents: "none",
        }}
      />
      <div
        className="position-absolute rounded-circle"
        style={{
          width: "450px",
          height: "450px",
          background: "rgba(26, 60, 107, 0.02)",
          bottom: "20%",
          left: "-50px",
          filter: "blur(120px)",
          pointerEvents: "none",
        }}
      />

      {/* Hero Section */}
      <section className="container mb-5 position-relative z-1">
        <motion.div
          initial={{ scale: 0.98, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={springSettings}
          className="card border-0 bg-white overflow-hidden shadow-sm"
          style={{ borderRadius: "28px" }}
        >
          <div className="row g-0 align-items-center">
            <div className="col-lg-6">
              <img
                src={dataset.intro.image}
                className="w-100 h-100 object-fit-cover"
                style={{ minHeight: "320px", maxHeight: "480px" }}
                alt="Logistics Infrastructure"
              />
            </div>
            <div className="col-lg-6 p-4 p-md-5">
              <span
                className="badge px-3 py-2 mb-3 text-uppercase fw-semibold"
                style={{
                  backgroundColor: "rgba(26, 60, 107, 0.06)",
                  color: "#1a3c6b",
                  fontSize: "0.7rem",
                  borderRadius: "6px",
                }}
              >
                Institutional Logistical Rollout
              </span>
              <h2
                className="fw-bold mb-3 text-dark"
                style={{
                  letterSpacing: "-1px",
                  fontSize: "1.85rem",
                  lineHeight: "1.3",
                }}
              >
                {dataset.intro.title}
              </h2>
              <p
                className="text-secondary small mb-0"
                style={{ lineHeight: "1.7" }}
              >
                {dataset.intro.description} Built on clean extraction variables,
                precise laboratory testing pipelines, and an uncompromised
                supply structure managed diligently by{" "}
                <strong>Ponia Food And Beverage Private Limited</strong> (CIN:
                U11043UP2024PTC213517, Aligarh, Uttar Pradesh).
              </p>
            </div>
          </div>
        </motion.div>
      </section>

      {/* Grid Modules Render */}
      <section className="container my-5 position-relative z-1">
        <header className="text-center mb-5">
          <h3
            className="fw-bold tracking-tight text-dark mb-2"
            style={{ letterSpacing: "-0.8px" }}
          >
            Commercial Growth Coordinates
          </h3>
        </header>
        <div className="row g-4 justify-content-center">
          {dataset.futureGrowth.map((point, index) => (
            <div className="col-md-6 col-lg-3" key={index}>
              <div
                className="card border-0 bg-white p-4 h-100 shadow-sm"
                style={{ borderRadius: "20px" }}
              >
                <div className="text-primary mb-3">
                  <BsArrowUpCircleFill className="fs-3 text-info" />
                </div>
                <h6 className="fw-bold text-dark mb-2">
                  Expansion Map 0{index + 1}
                </h6>
                <p
                  className="text-secondary mb-0 small"
                  style={{ lineHeight: "1.6" }}
                >
                  {point}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Perks and Corporate Mandates lists */}
      <section className="container my-5 position-relative z-1">
        <header className="text-center mb-5">
          <h3
            className="fw-bold tracking-tight text-dark mb-2"
            style={{ letterSpacing: "-0.8px" }}
          >
            Ecosystem Integration Perks
          </h3>
        </header>
        <div className="row g-3">
          {dataset.benefits.map((benefit, index) => (
            <div className="col-md-6 col-lg-4" key={index}>
              <div
                className="card border-0 bg-white p-4 h-100 d-flex flex-row gap-3 align-items-start shadow-xs"
                style={{ borderRadius: "18px" }}
              >
                <div
                  className="p-2.5 bg-light rounded-3 text-secondary d-flex align-items-center justify-content-center"
                  style={{ fontSize: "1.25rem" }}
                >
                  {benefit.icon}
                </div>
                <div>
                  <h6
                    className="fw-bold text-dark mb-1"
                    style={{ fontSize: "0.95rem" }}
                  >
                    {benefit.title}
                  </h6>
                  <p className="text-muted small mb-0">{benefit.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Operational Constants Block */}
      <section className="container my-5 position-relative z-1">
        <div
          className="card border-0 p-4 p-md-5 text-white shadow-sm"
          style={{ backgroundColor: "#1a3c6b", borderRadius: "24px" }}
        >
          <div className="text-center mb-4">
            <span
              className="text-uppercase tracking-wider fw-bold text-info small"
              style={{ fontSize: "0.7rem", letterSpacing: "1.5px" }}
            >
              Ecosystem Standardization
            </span>
            <h3
              className="fw-bold m-0 mt-1"
              style={{ letterSpacing: "-0.5px" }}
            >
              Operational Constants with NGO Waters
            </h3>
          </div>
          <div className="row g-3 justify-content-center">
            {dataset.businessBenefits.map((benefit, index) => (
              <div className="col-sm-6 col-md-3" key={index}>
                <div
                  className="card border-0 bg-white text-center p-3 h-100 d-flex flex-column align-items-center justify-content-center"
                  style={{ borderRadius: "16px" }}
                >
                  <div className="mb-2">{benefit.icon}</div>
                  <h6 className="text-dark fw-bold mb-0 small">
                    {benefit.title}
                  </h6>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Logistical Stats Gallery */}
      <section className="container my-5 position-relative z-1">
        <div className="row g-4 justify-content-center">
          {dataset.stats.map((stat, index) => (
            <div className="col-md-4" key={index}>
              <div
                className="card border-0 bg-white overflow-hidden shadow-sm h-100 d-flex flex-column justify-content-between"
                style={{ borderRadius: "24px" }}
              >
                <div
                  style={{ height: "200px" }}
                  className="overflow-hidden bg-light"
                >
                  <img
                    src={stat.image}
                    className="w-100 h-100 object-fit-cover"
                    alt="Capacity Log"
                  />
                </div>
                <div className="p-3 text-center bg-white border-top border-light">
                  <h6 className="fw-bold text-dark m-0 small">{stat.title}</h6>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Sustainable Alliance Block */}
      <section className="container my-5 position-relative z-1">
        <div
          className="card border-0 bg-white overflow-hidden shadow-sm"
          style={{ borderRadius: "28px" }}
        >
          <div className="row g-0 align-items-stretch">
            <div className="col-lg-5 position-relative bg-light">
              <img
                src={cleanWater}
                className="w-100 h-100 object-fit-cover"
                style={{ minHeight: "260px" }}
                alt="Purity Manifest"
              />
            </div>
            <div
              className="col-lg-7 p-4 p-md-5 d-flex flex-column justify-content-center"
              style={{ backgroundColor: "rgba(26,60,107,0.01)" }}
            >
              <div className="d-flex align-items-center gap-2 mb-3">
                <BsBriefcaseFill className="text-secondary" />
                <h4 className="fw-bold m-0 text-dark fs-5">
                  Our Local Footprint & Corporate Social Mandates
                </h4>
              </div>
              <ul className="list-unstyled d-flex flex-column gap-3 mb-0">
                {dataset.communityImpact.map((impact, index) => (
                  <li key={index} className="d-flex align-items-start gap-3">
                    <div
                      className="p-2 bg-white border rounded-circle d-flex align-items-center justify-content-center mt-0.5"
                      style={{ width: "36px", height: "36px" }}
                    >
                      {impact.icon}
                    </div>
                    <div>
                      <strong className="text-dark small d-block mb-0.5">
                        {impact.title}
                      </strong>
                      <span className="text-muted small">{impact.desc}</span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* ================= HIGH LEVEL FRANCHISE REGISTER INTENT FORM ================= */}
      <section
        className="container my-5 position-relative z-1"
        style={{ maxWidth: "840px" }}
      >
        <motion.div
          initial={{ y: 25, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true }}
          transition={springSettings}
          className="card border-0 p-4 p-md-5 bg-white shadow-sm"
          style={{
            borderRadius: "24px",
            border: "1px solid rgba(0,0,0,0.015)",
          }}
        >
          <div className="text-center mb-4">
            <h3
              className="fw-bold text-dark mb-1"
              style={{ letterSpacing: "-0.8px" }}
            >
              Register Distribution Intent
            </h3>
            <p className="text-muted small">
              Please submit accurate commercial, infrastructure, and
              geographical details to verify franchise onboarding criteria.
            </p>
          </div>

          <AnimatePresence mode="wait">
            {submissionStatus.message && (
              <motion.div
                initial={{ opacity: 0, y: -8 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -8 }}
                className="alert p-3 mb-4 small border-0"
                style={{
                  backgroundColor:
                    submissionStatus.type === "success"
                      ? "rgba(40,167,69,0.06)"
                      : "rgba(220,53,69,0.06)",
                  color:
                    submissionStatus.type === "success" ? "#1e7e34" : "#bd2130",
                  borderRadius: "10px",
                }}
              >
                {submissionStatus.message}
              </motion.div>
            )}
          </AnimatePresence>

          <form onSubmit={handleFormSubmit}>
            {/* Section 1: Contact Profiling */}
            <h5
              className="fw-bold text-primary mb-3 pb-2 border-bottom style-title"
              style={{ fontSize: "1.05rem" }}
            >
              1. Applicant & Entity Particulars
            </h5>
            <div className="row g-3 mb-4">
              <div className="col-md-6">
                <label
                  htmlFor="name"
                  className="form-label small fw-semibold text-dark mb-1"
                >
                  Full Applicant Name *
                </label>
                <input
                  type="text"
                  className="form-control px-3 py-2 bg-light border-0"
                  id="name"
                  value={formInputs.name}
                  onChange={handleInputChange}
                  placeholder="E.g., Rahul Sharma"
                  style={{ borderRadius: "8px", fontSize: "0.88rem" }}
                  required
                />
              </div>
              <div className="col-md-6">
                <label
                  htmlFor="firmName"
                  className="form-label small fw-semibold text-dark mb-1"
                >
                  Firm / Company Name (If Any)
                </label>
                <input
                  type="text"
                  className="form-control px-3 py-2 bg-light border-0"
                  id="firmName"
                  value={formInputs.firmName}
                  onChange={handleInputChange}
                  placeholder="E.g., Sharma Logistics & Traders"
                  style={{ borderRadius: "8px", fontSize: "0.88rem" }}
                />
              </div>
              <div className="col-md-6">
                <label
                  htmlFor="email"
                  className="form-label small fw-semibold text-dark mb-1"
                >
                  Email Address *
                </label>
                <input
                  type="email"
                  className="form-control px-3 py-2 bg-light border-0"
                  id="email"
                  value={formInputs.email}
                  onChange={handleInputChange}
                  placeholder="operator@domain.com"
                  style={{ borderRadius: "8px", fontSize: "0.88rem" }}
                  required
                />
              </div>
              <div className="col-md-6">
                <label
                  htmlFor="mobile"
                  className="form-label small fw-semibold text-dark mb-1"
                >
                  Mobile Number (WhatsApp Verified) *
                </label>
                <input
                  type="tel"
                  className="form-control px-3 py-2 bg-light border-0"
                  id="mobile"
                  value={formInputs.mobile}
                  onChange={handleInputChange}
                  placeholder="10-digit phone number"
                  style={{ borderRadius: "8px", fontSize: "0.88rem" }}
                  required
                />
              </div>
            </div>

            {/* Section 2: Geographic Matrix */}
            <h5
              className="fw-bold text-primary mb-3 pb-2 border-bottom"
              style={{ fontSize: "1.05rem" }}
            >
              2. Target Distribution Area
            </h5>
            <div className="row g-3 mb-4">
              <div className="col-md-4">
                <label
                  htmlFor="pincode"
                  className="form-label small fw-semibold text-dark mb-1"
                >
                  Proposed Pincode Matrix *
                </label>
                <input
                  type="text"
                  className="form-control px-3 py-2 bg-light border-0"
                  id="pincode"
                  value={formInputs.pincode}
                  onChange={handleInputChange}
                  placeholder="6-digit code"
                  style={{ borderRadius: "8px", fontSize: "0.88rem" }}
                  required
                />
              </div>
              <div className="col-md-4">
                <label
                  htmlFor="city"
                  className="form-label small fw-semibold text-dark mb-1"
                >
                  Target City *
                </label>
                <input
                  type="text"
                  className="form-control px-3 py-2 bg-light border-0"
                  id="city"
                  value={formInputs.city}
                  onChange={handleInputChange}
                  placeholder="City Point"
                  style={{ borderRadius: "8px", fontSize: "0.88rem" }}
                  required
                />
              </div>
              <div className="col-md-4">
                <label
                  htmlFor="state"
                  className="form-label small fw-semibold text-dark mb-1"
                >
                  State Region *
                </label>
                <input
                  type="text"
                  className="form-control px-3 py-2 bg-light border-0"
                  id="state"
                  value={formInputs.state}
                  onChange={handleInputChange}
                  placeholder="State Territory"
                  style={{ borderRadius: "8px", fontSize: "0.88rem" }}
                  required
                />
              </div>
            </div>

            {/* Section 3: Commercial Logistics & Capacity */}
            <h5
              className="fw-bold text-primary mb-3 pb-2 border-bottom"
              style={{ fontSize: "1.05rem" }}
            >
              3. Investment & Commercial Capabilities
            </h5>
            <div className="row g-3 mb-4">
              <div className="col-md-6">
                <label
                  htmlFor="investmentCapacity"
                  className="form-label small fw-semibold text-dark mb-1"
                >
                  Investment Capacity Tiers *
                </label>
                <select
                  className="form-select px-3 py-2 bg-light border-0"
                  id="investmentCapacity"
                  value={formInputs.investmentCapacity}
                  onChange={handleInputChange}
                  style={{ borderRadius: "8px", fontSize: "0.88rem" }}
                  required
                >
                  <option value="">Select Capital Allocation Tier</option>
                  <option value="2-5 Lakhs">₹2 Lakhs - ₹5 Lakhs</option>
                  <option value="5-10 Lakhs">₹5 Lakhs - ₹10 Lakhs</option>
                  <option value="10-15 Lakhs">₹10 Lakhs - ₹15 Lakhs</option>
                  <option value="15 Lakhs+">Above ₹15 Lakhs</option>
                </select>
              </div>
              <div className="col-md-6">
                <label
                  htmlFor="storageSpace"
                  className="form-label small fw-semibold text-dark mb-1"
                >
                  Available Warehouse / Storage Space (Sq. Ft) *
                </label>
                <input
                  type="text"
                  className="form-control px-3 py-2 bg-light border-0"
                  id="storageSpace"
                  value={formInputs.storageSpace}
                  onChange={handleInputChange}
                  placeholder="E.g., 500 Sq. Ft, 1200 Sq. Ft"
                  style={{ borderRadius: "8px", fontSize: "0.88rem" }}
                  required
                />
              </div>
              <div className="col-md-6">
                <label
                  htmlFor="existingBusiness"
                  className="form-label small fw-semibold text-dark mb-1"
                >
                  Current Line of Business / Profession
                </label>
                <input
                  type="text"
                  className="form-control px-3 py-2 bg-light border-0"
                  id="existingBusiness"
                  value={formInputs.existingBusiness}
                  onChange={handleInputChange}
                  placeholder="E.g., FMCG Distributor, Retailer, Real Estate"
                  style={{ borderRadius: "8px", fontSize: "0.88rem" }}
                />
              </div>
              <div className="col-md-6">
                <label
                  htmlFor="distributionExperience"
                  className="form-label small fw-semibold text-dark mb-1"
                >
                  Prior Distribution Experience (Years) *
                </label>
                <select
                  className="form-select px-3 py-2 bg-light border-0"
                  id="distributionExperience"
                  value={formInputs.distributionExperience}
                  onChange={handleInputChange}
                  style={{ borderRadius: "8px", fontSize: "0.88rem" }}
                  required
                >
                  <option value="">Select Experience Duration</option>
                  <option value="No Experience">
                    Fresher / No Prior Experience
                  </option>
                  <option value="1-3 Years">1 - 3 Years</option>
                  <option value="3-5 Years">3 - 5 Years</option>
                  <option value="5+ Years">More than 5 Years</option>
                </select>
              </div>
              <div className="col-md-6">
                <label
                  htmlFor="vehicleAvailable"
                  className="form-label small fw-semibold text-dark mb-1"
                >
                  Do you own Commercial Delivery Vehicles? *
                </label>
                <select
                  className="form-select px-3 py-2 bg-light border-0"
                  id="vehicleAvailable"
                  value={formInputs.vehicleAvailable}
                  onChange={handleInputChange}
                  style={{ borderRadius: "8px", fontSize: "0.88rem" }}
                  required
                >
                  <option value="No">No / Will Arrange</option>
                  <option value="Yes (Three Wheeler/Tempo)">
                    Yes (Three Wheeler / Auto Tempo)
                  </option>
                  <option value="Yes (Four Wheeler Truck)">
                    Yes (Mini Truck / Four Wheeler)
                  </option>
                </select>
              </div>
              <div className="col-md-6">
                <label
                  htmlFor="infrastructureReady"
                  className="form-label small fw-semibold text-dark mb-1"
                >
                  Is the Office / Warehouse space ready for setup? *
                </label>
                <select
                  className="form-select px-3 py-2 bg-light border-0"
                  id="infrastructureReady"
                  value={formInputs.infrastructureReady}
                  onChange={handleInputChange}
                  style={{ borderRadius: "8px", fontSize: "0.88rem" }}
                  required
                >
                  <option value="No">No, currently searching space</option>
                  <option value="Yes, owned space ready">
                    Yes, owned infrastructure is ready
                  </option>
                  <option value="Yes, rented space ready">
                    Yes, leased/rented space is ready
                  </option>
                </select>
              </div>
              <div className="col-12">
                <label
                  htmlFor="additionalNotes"
                  className="form-label small fw-semibold text-dark mb-1"
                >
                  Specific Requirements / Strategic Comments
                </label>
                <textarea
                  className="form-control px-3 py-2 bg-light border-0"
                  id="additionalNotes"
                  rows="3"
                  value={formInputs.additionalNotes}
                  onChange={handleInputChange}
                  placeholder="Specify any unique territory targets or queries regarding institutional procurement contracts..."
                  style={{ borderRadius: "10px", fontSize: "0.88rem" }}
                ></textarea>
              </div>
            </div>

            {/* Submission Button */}
            <div className="d-grid mt-4">
              <motion.button
                whileHover={{ scale: isSubmitting ? 1 : 1.01 }}
                whileTap={{ scale: isSubmitting ? 1 : 0.99 }}
                transition={clickFeedback}
                type="submit"
                disabled={isSubmitting}
                className="btn text-white py-2.5 fw-bold border-0 d-flex align-items-center justify-content-center gap-2"
                style={{
                  backgroundColor: "#1a3c6b",
                  borderRadius: "12px",
                  fontSize: "0.92rem",
                }}
              >
                {isSubmitting ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span>Processing Intent Pipeline...</span>
                  </>
                ) : (
                  <>
                    <BsSendFill className="small" /> File Distributorship
                    Application
                  </>
                )}
              </motion.button>
            </div>
          </form>
        </motion.div>
      </section>

      <footer
        className="container mt-5 text-center text-muted"
        style={{ fontSize: "0.72rem" }}
      >
        <div className="d-flex align-items-center justify-content-center gap-1.5 mb-1 text-secondary fw-bold">
          <BsGeoAltFill className="text-muted" />
          <span>
            PONIA FOOD AND BEVERAGE PVT. LTD. • FRANCHISE DESK EXECUTIONS
          </span>
        </div>
        Operational statistics, plant throughput assets, and regional pincode
        allocations are systematically audited under manufacturing laws.
      </footer>
    </motion.div>
  );
};

export default Distributor;
